import { FlightPassengerSelection as CoreFlightPassengerSelection } from "@b2bportal/core-flights";
import { useModuleBEM } from "@b2bportal/core-themes";
import { CoreFlightsComponent } from "@b2bportal/core-types";
import { useI18nContext } from "@hopper-b2b/i18n";
import styles from "./styles.module.scss";

export const FlightPassengerSelection = (props) => {
  const [, cn] = useModuleBEM(
    styles,
    CoreFlightsComponent.FlightPassengerSelection
  );
  const { t } = useI18nContext();

  return (
    <CoreFlightPassengerSelection
      {...props}
      ariaLabel={t("flightsPageTitles.travellers")}
    >
      <div className={cn("children-disclaimer-alert-container")}>
        <span className={cn("children-disclaimer-alert-title")}>
          {t("home.childrenSelectionDisclaimerTitle")}
        </span>
        <span className={cn("children-disclaimer-alert-subtitle")}>
          {t("home.childrenSelectionDisclaimerSubtitle")}
        </span>
      </div>
    </CoreFlightPassengerSelection>
  );
};
